// extracted by css-extract-rspack-plugin
export default {"list":"list-wIRAmN","emptyItem":"emptyItem-C09HOC","item":"item-bdU5rV","itemLabel":"itemLabel-PF2S0E","footer":"footer-tQ1ZNs"};